<template>
    <div v-if="!state.loading">
    <div class="pgehd">
        <h2>{{state.title}}</h2>
    </div>
    
    <PrimeDataTable
        :value="list"
        :rows="10"
        responsiveLayout="scroll"
        stripedRows>
        <PrimeColumn field="sn" header="sn" />
        <PrimeColumn field="name" header="Name" />
        <PrimeColumn field="date" header="Date" />
    </PrimeDataTable>
  </div>
  <div v-else class="loader">
    <img src="@/assets/img/ajldr.gif" />
  </div>
</template>
<script>
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { onMounted, reactive, ref,computed} from 'vue';
import { useRoute } from "vue-router";

export default {
    name:"StudentsView",
    setup(){
        const route = useRoute();
        const type = computed(() => route.params.type)
        const list = ref([])
        const globalFilter=ref("")
        const state=reactive({loading:true,title:"Student Birthdays"})
        if(type.value=="today"){
            state.title="Today's Birthday"
        }

        function setTable(d){
            if (!Array.isArray(d)) {
                list.value = Object.values(d)
            } else {
                list.value = d
            }
        }
        
        onMounted(() => {
            call({
                url:urls.students,
                data:{getStudentsBirthday:type.value},
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        setTable(res.msg.list)
                    }else{
                        alert(res.msg);
                    }
                }
            })
        });

        
        return{state,globalFilter,list}
    }
}

</script>